<template>
<div class='wx-bind-view login-form'>
  <h1>抱歉，该页面功能正在开发中...</h1>
  <!-- <h1>{{$t('actions.wxbind.title')}}</h1>
  <el-form ref="login">
    <el-form-item :class="{'is-error': errors.has('email')}">
      <el-input v-validate data-vv-rules="required|email" data-vv-name="email" v-model="form.email" :placeholder="$t('placeholder.user.email')">
      </el-input>
      <span class="el-form-item__error">{{errors.first('email')}}</span>
    </el-form-item>

    <el-form-item :class="{'is-error': errors.has('password')}">
      <el-input v-validate data-vv-rules="required" data-vv-name="密码" v-model="form.password" type='password' :placeholder="$t('placeholder.user.password')">
      </el-input>
      <span class="el-form-item__error">{{errors.first('password')}}</span>
    </el-form-item>

    <el-form-item>
      <el-button @click.native="wxbind" type="primary submit-btn">{{$t('actions.wxbind.submit')}}</el-button>
    </el-form-item>

    <el-form-item>
      <div class='left'>
        <router-link to='login'>
          {{$t('actions.login.accountlogin')}}
        </router-link>
      </div>
      <div class='right'>
        <router-link to="/register">{{$t('actions.login.register')}}</router-link>&nbsp;|
        <router-link to="password">{{$t('actions.login.password')}}</router-link>
      </div>
    </el-form-item>
  </el-form> -->
</div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        email: null,
        password: null
      }
    }
  },
  methods: {
    wxbind() {
      alert('send wxbind request')
    }
  }
}
</script>
<style lang='scss' scoped>
.wx-bind-view {}</style>



// WEBPACK FOOTER //
// wxbind.view.vue?02def01e